import { createFcmContext } from 'src/app/shared/contexts/fcm';
import { FCM_MEMBERSHIP_BOTTOM_BANNER_ENABLED_FOR } from 'src/app/shared/fcm/configs';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: MembershipBottomBannerFcmContext,
	FcmProvider: MembershipBottomBannerFcmContextProvider,
	useFcm: useMembershipBottomBannerFcm,
	useAsyncFcm: useAsyncMembershipBottomBannerFcm,
	prefetchFcm: prefetchMembershipBottomBannerFcm,
} = createFcmContext({
	name: 'MembershipBottomBannerFcmContext',
	dataProperty: 'fcm',
	configs: {
		membershipBottomBannerEnabled: FCM_MEMBERSHIP_BOTTOM_BANNER_ENABLED_FOR,
	},
	prefetch: true,
});

export type MembershipBottomBannerFcmState = ReturnType<typeof useAsyncMembershipBottomBannerFcm>;
export type MembershipBottomBannerFcm = LoadedStateData<MembershipBottomBannerFcmState>;
